import { render, staticRenderFns } from "./AccountsStripeCallback.vue?vue&type=template&id=f5410610"
import script from "./AccountsStripeCallback.vue?vue&type=script&lang=js"
export * from "./AccountsStripeCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5410610')) {
      api.createRecord('f5410610', component.options)
    } else {
      api.reload('f5410610', component.options)
    }
    module.hot.accept("./AccountsStripeCallback.vue?vue&type=template&id=f5410610", function () {
      api.rerender('f5410610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Login/AccountsStripeCallback.vue"
export default component.exports